import { CarBrandResource as Res } from '@shared/resources/car-brand';
import { CarBrandCreateUpdateDto as DTO } from '@shared/dto/car-brand';
import { CarBrandService } from '@/services/car-brand.service';
import { defineCrudStore } from '@/stores/crud-store';

export const useCarBrandsStore = defineCrudStore<DTO, DTO, Res>({
  storeId: 'carBrands',
  service: new CarBrandService(),
});
